/* Skintique: pin the sidebar mega-menu category panel to the top of the brand rail.
   The Enterprise theme anchors each brand's .disclosure__panel to that brand's row,
   so categories appear pushed down. This recomputes each panel's top to align with
   the top of .child-nav. Triggers: any hover in the header (debounced) + a class
   MutationObserver on the mega nav (catches the .is-visible toggle) + load/resize. */
(function () {
  function fixOne(p) {
    var sb = p.closest('.mega-nav--sidebar'); if (!sb) return;
    var cn = sb.querySelector('.child-nav'); var li = p.closest('li'); if (!cn || !li) return;
    var delta = cn.getBoundingClientRect().top - li.getBoundingClientRect().top;
    p.style.setProperty('top', delta + 'px', 'important');
    p.style.setProperty('min-height', cn.offsetHeight + 'px', 'important');
  }
  function fix() {
    if (window.innerWidth < 769) return;
    document.querySelectorAll('.mega-nav--sidebar .child-nav__item--toggle + .disclosure__panel').forEach(fixOne);
  }
  var raf;
  function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(fix); }
  document.addEventListener('mouseover', schedule, true);
  document.addEventListener('focusin', schedule, true);
  window.addEventListener('resize', schedule);
  window.addEventListener('load', fix);
  function init() {
    fix();
    document.querySelectorAll('.mega-nav--sidebar').forEach(function (sb) {
      try { new MutationObserver(schedule).observe(sb, { attributes: true, attributeFilter: ['class'], subtree: true }); } catch (e) {}
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
